<template>
  <div class="article-card-skeleton" aria-hidden="true">
    <div class="article-card-skeleton__image" />
    <div class="article-card-skeleton__content">
      <div class="article-card-skeleton__meta" />
      <div class="article-card-skeleton__title" />
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.article-card-skeleton {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--color-border-card, #E5E7EB);
}

.article-card-skeleton__image {
  width: 100%;
  aspect-ratio: 360 / 240;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.article-card-skeleton__content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.article-card-skeleton__meta {
  height: 18px;
  width: 70%;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
  animation-delay: 0.1s;
}

.article-card-skeleton__title {
  height: 24px;
  width: 100%;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
  animation-delay: 0.2s;
}

@keyframes skeleton-shimmer {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 200% 0;
  }
}
</style>
